import { FormEvent } from "react"
import { Head, Link, useForm, usePage } from "@inertiajs/react"
import { AdminShell } from "@/components/AdminShell"
import { Button } from "@/components/ui/button"
import { Checkbox } from "@/components/ui/checkbox"
import { Input } from "@/components/ui/input"

import type { PageProps } from "@/types/inertia"

export default function AdminUsersNew() {
  const { props } = usePage<PageProps>()
  const form = useForm({
    email: "",
    password: "",
    timezone: "",
    admin: false,
  })

  const submit = (event: FormEvent) => {
    event.preventDefault()
    form.post("/admin/users")
  }

  return (
    <>
      <Head title="New editor">
        <meta name="description" content="Create an editor account." />
        <meta property="og:title" content="New editor" />
        <meta property="og:description" content="Create an editor account." />
      </Head>
      <AdminShell>
        <div className="border-b border-hairline pb-6">
          <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
            <div>
              <h1>New editor</h1>
              <p className="mt-1">Create an account for someone on the editorial team.</p>
            </div>
            <Link
              href="/admin/users"
              className="text-sm text-ink-muted no-underline hover:text-ink-display"
            >
              Back to users
            </Link>
          </div>
        </div>

        <form onSubmit={submit} className="mt-6 max-w-xl space-y-4">
          <FieldError error={props.errors?.base} />
          <div className="space-y-2">
            <label htmlFor="email">Email</label>
            <Input
              id="email"
              type="email"
              autoComplete="email"
              required
              value={form.data.email}
              onChange={(event) => form.setData("email", event.target.value)}
            />
            <FieldError error={props.errors?.email} />
          </div>

          <div className="space-y-2">
            <label htmlFor="password">Temporary password</label>
            <Input
              id="password"
              type="password"
              autoComplete="new-password"
              required
              value={form.data.password}
              onChange={(event) => form.setData("password", event.target.value)}
            />
            <FieldError error={props.errors?.password} />
          </div>

          <div className="space-y-2">
            <label htmlFor="timezone">Timezone</label>
            <Input
              id="timezone"
              type="text"
              placeholder="Europe/Zagreb"
              value={form.data.timezone}
              onChange={(event) => form.setData("timezone", event.target.value)}
            />
            <FieldError error={props.errors?.timezone} />
          </div>

          <label className="flex items-center gap-3 text-sm">
            <Checkbox
              checked={form.data.admin}
              onChange={(event) => form.setData("admin", event.target.checked)}
            />
            Admin user
          </label>

          <Button type="submit" disabled={form.processing}>
            Create editor
          </Button>
        </form>
      </AdminShell>
    </>
  )
}

function FieldError({ error }: { error?: string }) {
  if (!error) return null

  return <p className="text-sm text-danger-display">{error}</p>
}
